module.exports = __webpack_public_path__ + "static/media/Engxg4.a6432060.png";